import { render } from "./PlanContainerResultLoadingSchemeJournal.vue?vue&type=template&id=194327e4&ts=true"
import script from "./PlanContainerResultLoadingSchemeJournal.vue?vue&type=script&lang=ts"
export * from "./PlanContainerResultLoadingSchemeJournal.vue?vue&type=script&lang=ts"

import "./PlanContainerResultLoadingSchemeJournal.vue?vue&type=style&index=0&id=194327e4&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\330398ee0e098db7\\LoadingSokoldok\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__